import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-csv-download-popup',
  templateUrl: './csv-download-popup.component.html',
  styleUrls: ['./csv-download-popup.component.scss']
})
export class CsvDownloadPopupComponent {

  button_loader: boolean = false;
  selected_csv_category: any;
  csv_category: any[] = [
    {
      label: 'User List',
      value: 'user_info'
    },
    {
      label: 'App Open Event',
      value: 'app_open_event'
    },
    {
      label: 'Bingo Card Downloads',
      value: 'bingo_card_downloads'
    },
    {
      label: 'Trial Checkins',
      value: 'trail'
    },
    {
      label: 'Bingo Card Completion',
      value: 'bingo_card_completion'
    },
    {
      label: 'Funtivity Card Downloads',
      value: 'funtivity_card_downloads'
    },
    {
      label: 'Funtivity Checkins',
      value: 'funtivity_checkins'
    },
    {
      label: 'Funtivity Card Completion',
      value: 'funtivity_card_completion'
    },
    {
      label: 'Daily Quests',
      value: 'daily_quests'
    },
    {
      label: 'Badge Unlocks',
      value: 'badge_unlocks'
    },
    {
      label: 'Current Events',
      value: 'current_events'
    },
    {
      label: 'Past Events',
      value: 'past_events'
    },
  ]

  constructor(
    public dialogRef: MatDialogRef<CsvDownloadPopupComponent>,
    private toast: ToastrService
  ) {

  }

  submit() {

    this.button_loader = true;

    if (!this.selected_csv_category) {
      this.toast.warning(`Please select a csv type to download`, 'Warning', {
        closeButton: true,
      });
      this.button_loader = false;
    } else {
      this.closeModal(this.selected_csv_category?.value)
    }
  }

  selectCSVType(data: any) {
    this.selected_csv_category = data;
  }

  closeModal(type: string) {
    this.dialogRef.close(type);
  }

  close() {
    this.dialogRef.close();
  }

}
